import API from '../api'

export default class Grid {
  constructor(element) {
    this.grid = element
    this.api = this.grid.dataset.api

    this.container = this.grid.querySelector('.js-container')
    this.btnMore = this.grid.querySelector('.js-more')
    this.parent = this.grid.closest('.grid-container')

    this.btnMore.addEventListener('click', () => {
      this.getEvents()
    })
  }

  init(query) {
    this.page = 1
    this.container.innerHTML = ''
    this.query = query

    return this.getEvents().then(() => {})
  }

  getEvents() {
    this.grid.classList.add('is-loading')
    this.isEmpty = false

    return API.getIndex(this.api, this.page++, this.query).then((response) => {
      this.container.innerHTML += response
      const isDone = this.container.querySelector('input[name="done"]')

      this.grid.classList.remove('is-loading')
      this.btnMore.classList.toggle('is-hidden', isDone)

      if (isDone && isDone.value == 0) {
        this.isEmpty = true
      }
    })
  }

  toggle(state) {
    this.parent.classList.toggle('is-hidden', state)
  }
}
